import { Calendar } from "lucide-react";
import {
  getImportantDates,
  buildAddToCalendarUrl,
  SHORT_LABEL,
} from "../../utils/importantDates";

const URGENCY_CLASS = {
  past: "text-gray-400",
  soon: "text-amber-600",
  future: "text-gray-700",
  unset: "text-gray-400",
};

function daysAwayCopy(daysAway) {
  if (daysAway === null) return "Not Set";
  if (daysAway < 0) return "";
  if (daysAway === 0) return "Today";
  if (daysAway === 1) return "In 1 Day";
  return `In ${daysAway} Days`;
}

function formatDate(dateObj) {
  if (!dateObj) return "—";
  return dateObj.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export default function ImportantDatesPanel({ deal, embedded = false }) {
  const rows = getImportantDates(deal);

  const handleAddToCalendar = (row) => {
    const url = buildAddToCalendarUrl({
      title: `${SHORT_LABEL[row.field]} — ${deal?.propertyaddress || "Deal"}`,
      isoDate: row.isoDate,
      description: `Property: ${deal?.propertyaddress || ""}${
        deal?.clientLastName ? ` — ${deal.clientLastName}` : ""
      }`,
    });
    if (url) window.open(url, "_blank", "noopener,noreferrer");
  };

  // When embedded inside another card (Deal Summary), drop our own card
  // chrome so we don't render a nested-bordered box. The parent provides
  // the surrounding card. Sits at the top of the Deal Summary now, so
  // the divider goes below us instead of above.
  const outerClass = embedded
    ? "pt-4 pb-4 border-b border-black/10"
    : "bg-white border border-gray-200 rounded-lg p-4 mb-4";

  return (
    <div className={outerClass}>
      <div className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
        Important Dates
      </div>
      <div>
        {rows.map((row, i) => (
          <div
            key={row.field}
            className={`flex justify-between items-center py-2 ${
              i < rows.length - 1 ? "border-b border-gray-100" : ""
            }`}
          >
            <div className="text-sm text-gray-600">{row.label}</div>
            <div className="flex items-center gap-3">
              <div className="text-right">
                <span
                  className={`text-sm font-semibold ${URGENCY_CLASS[row.urgency]}`}
                >
                  {formatDate(row.dateObj)}
                </span>
                {daysAwayCopy(row.daysAway) && (
                  <span
                    className={`text-xs ml-2 ${URGENCY_CLASS[row.urgency]}`}
                  >
                    {daysAwayCopy(row.daysAway)}
                  </span>
                )}
              </div>
              {row.urgency !== "unset" && (
                <button
                  type="button"
                  onClick={() => handleAddToCalendar(row)}
                  className="text-gray-400 hover:text-blue-600 p-1"
                  aria-label={`Add ${row.label} to Google Calendar`}
                  title="Add to Google Calendar"
                >
                  <Calendar size={16} />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
